export const frontmatter = {
  title: "Авторы и контакты",
  slug: "authors",
  category: "О проекте",
  reading_minutes: 2,
  updated: "2026-04-29",
  abstract: "Кто делает Geobiom, как связаться и как поддержать проект.",
};

import { Callout, KeyFacts, TLDR } from "../../components/mdx";

# Авторы и контакты

<TLDR>
Geobiom — авторский проект одного человека. Без команды, без стартапа, без монетизации. Это большое хобби, выросшее из любви к лесу и привычки доводить дела до конца.
</TLDR>

<KeyFacts title="Контакты" facts={[
  { label: "Автор", value: "Иван Кочеров" },
  { label: "GitHub", value: <><a href="https://github.com/yungkocherov/mushroom_map/issues">yungkocherov/mushroom_map</a> — лучший канал для багов и идей</> },
  { label: "Email", value: <><a href="mailto:ikocherov@mail.ru">ikocherov@mail.ru</a> — для деликатных вопросов</> },
  { label: "Время ответа", value: "не всегда быстро, но читаю всё" },
]} />

## Что делается

Хочу, чтобы у грибника-любителя был один сайт, где видно лес как структуру: тип, возраст, сродство к видам, влажность, рельеф — а не россыпь форумных постов и приложений-определителей. Технический фундамент сейчас — основной фокус: ~2 млн полигонов выделов из ФГИС ЛК, рельеф Copernicus, почвы Докучаевского, классификатор фото из ВК-сообществ, контракт API под будущую ML-модель в сестринском репо `mushroom-forecast`.

## Как поддержать

<Callout type="info" title="Без денег. Без рекламы. Без инвестиций.">
Geobiom не монетизируется и не собирается. Если хочется помочь — есть три формы:
</Callout>

- **Указать ошибку в данных** — если знаете, что в районе X на самом деле уже не сосняк, а гарь, или знакомое озеро в gazetteer'е названо неправильно — напишите в issue, поправим.
- **Прислать фото с наблюдением** — особенно ценны нетипичные находки и редкие виды. Контекст (район, дата, тип леса) важнее качества снимка.
- **Рассказать другому грибнику** — лучшая форма обратной связи. Если карта оказалась полезна, расскажите тем, кому она может пригодиться.

## Лицензия и данные

Исходный код — открытый ([yungkocherov/mushroom_map](https://github.com/yungkocherov/mushroom_map)). Лицензия — в репозитории. Данные карты — производные открытых источников: Рослесхоз/ФГИС ЛК (лесные выделы), OpenStreetMap (гидрография, дороги, ООПТ), Copernicus GLO-30 DEM (рельеф), Почвенная карта Докучаевского ин-та (почвы). Атрибуция — на странице [«Лесные данные»](/methodology/forest-data) и в подвалах слоёв.
